import { c as _c } from "react/compiler-runtime";
import type { Offer } from '@repo/contracts/marketplace/offers/types';
import type { SegmentActionNamePrefixType } from '../../../model/types';
import { type CtaAnalyticsProps, CtaLink } from '../../CTA/CtaLink';
import { NWIcon } from '../../Icons';
import { Accordion } from '../Accordion';
import { ProsCons } from './ProsCons';
export const NerdwalletsTake = t0 => {
  const $ = _c(14);
  const {
    actionSection,
    analytics,
    creditCardOffer,
    segmentActionNamePrefix
  } = t0;
  const {
    details: t1
  } = creditCardOffer;
  const {
    cons,
    pros,
    reviewLink
  } = t1;
  const t2 = `${segmentActionNamePrefix}_nw_take`;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <NWIcon />;
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  let t4;
  if ($[1] !== cons || $[2] !== pros) {
    t4 = <ProsCons pros={pros} cons={cons} />;
    $[1] = cons;
    $[2] = pros;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== reviewLink) {
    t5 = reviewLink && <CtaLink target="_blank" href={reviewLink} analytics={{}} parameterActions={[]} skipShoppingFinishedEvent={true} isReview={true} underline="hover">Read full review</CtaLink>;
    $[4] = reviewLink;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t4 || $[7] !== t5) {
    t6 = <div data-testid="nerdWalletTakeInnerContent">{t4}{t5}</div>;
    $[6] = t4;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== actionSection || $[10] !== analytics.productSlug || $[11] !== t2 || $[12] !== t6) {
    t7 = <Accordion analyticsActionName={t2} actionSection={actionSection} analyticsKey="nw-take" productSlug={analytics.productSlug} iconComponent={t3} title="NerdWallet's take">{t6}</Accordion>;
    $[9] = actionSection;
    $[10] = analytics.productSlug;
    $[11] = t2;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
};